import { PersonActionType } from 'app/area/administration/shared/types';
import { AccessAdminInfoData } from 'app/types-shared';

export const hasAccess = (user: AccessAdminInfoData, actionType: PersonActionType) => {
  return actionType && {
    [PersonActionType.add]: !!user.create,
    [PersonActionType.edit]: !!user.read,
    [PersonActionType.duplicate]: !!user.create
  }[actionType];
};
